import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { take, filter, mergeMap } from 'rxjs/operators';

import { HeaderTitleService } from './core';

/**
 * AppComponent
 */
@Component({
	selector: 'app-pilotpay',
	encapsulation: ViewEncapsulation.None,
	template: '<app-errors></app-errors><router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
	constructor(
		private headerTitleService: HeaderTitleService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {}

	public ngOnInit(): void {
		// Update the page title on the initial page load
		this.headerTitleService
			.getTitle(this.activatedRoute)
			.pipe(take(1))
			.subscribe((title: string) => {
				this.headerTitleService.setTitle(title);
			});

		// Update the page title on route navigation
		this.router.events
			.pipe(
				filter((event: RouterEvent) => {
					return event instanceof NavigationEnd;
				}),
				mergeMap(() => this.headerTitleService.getTitle(this.activatedRoute))
			)
			.subscribe((title: string) => {
				this.headerTitleService.setTitle(title);
			});
	}
}
